import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { createInvoiceAssignment, fetchInvoices } from '../../../store/actions/invoicesActions'
import ModalActionButton from '../../elements/ModalActionButton'
import { debounce } from '../../../utils'
import SearchField from '../../elements/SearchField'
import Loader from '../../elements/Loader'
import EmptyState from '../../elements/EmptyState'
import { FeesDisplay } from '../../../pages/admin/accounting/invoices/Invoices'
import CheckIcon from '../../elements/icons/CheckIcon'
import { ERROR } from '../../../store/types'
import DateField from '../../elements/form/DateField'
import { Switch } from '@headlessui/react'
import SelectField from '../../elements/form/SelectField';

const AssignInvoiceToStudent = ({student, closeFunction, reload}) => {
    const dispatch = useDispatch()
    const invoicesSelector = useSelector(state => state.invoices)
    const [filters, setFilters] = useState('');
    const [pagination] = useState({
        page: 1,
        perPage: 25
    });

    useEffect(() => {
        dispatch(fetchInvoices(filters, pagination.page, pagination.perPage))
        
        return () => {
        
        };
    }, [dispatch, filters, pagination.page, pagination.perPage]);


    const searchInvoices = debounce((term) => {
        setSelectedInvoice('')
        setFilters(`name=${term}&applicationCode=${term}`)
        // dispatch(fetchInvoices(`name=${term}&applicationCode=${term}`, 0, 0))
    })

    const [selectedInvoice, setSelectedInvoice] = useState('');

    const toggleInvoiceSelection = (invoice) => {
        if(selectedInvoice._id === invoice._id) {
            setSelectedInvoice('')
        } else {
            setSelectedInvoice(invoice)
        }
    }

    const [paymentDeadline, setPaymentDeadline] = useState('');

    const validateForm = () => {
        let errors = {}

        if(sundriesRequirement.include) {
            if(!sundriesRequirement.dateFrom || sundriesRequirement.dateFrom === '') {
                errors.sundriesDateFrom = true
            }
            if(!sundriesRequirement.dateTo || sundriesRequirement.dateTo === '') {
                errors.sundriesDateTo = true
            }

            if(topupSundries && (!sundriesRequirement.sundryTopupFee || sundriesRequirement.sundryTopupFee === '')) {
                errors.sundryTopupFee = true
            }
        }

        setValidationErrors(errors)

        return errors
    }

    const pushAssignment = () => {
        if (Object.values(validateForm()).includes(true)) {
            dispatch({
                type: ERROR,
                error: {response: {data: {
                    message: 'Please check the highlighted fields'
                }}}
            })
            return
        }

        if(selectedInvoice === '') {
            dispatch({
                type: ERROR,
                error: {response: {data: {message:'Please select an invoice'}}}
            })
            return
        }

        const payload = {
            assignmentType: 'SPECIFIC',
            paymentDeadline: paymentDeadline || undefined,
            invoice: selectedInvoice._id,
            students: [student._id],
            sundries: sundriesRequirement,

        }

        dispatch(createInvoiceAssignment(payload))
    }

    const [sundriesRequirement, setSundriesRequirement] = useState({});
    const [topupSundries, setTopupSundries] = useState(false);
    const [validationErrors, setValidationErrors] = useState({});

    return (
        <div>
            {/* invoices list */}
            <div className='w-full overflow-y-scroll scrollbar-hidden'>
                <div className='my-2 w-full'>
                    <DateField
                        inputLabel="Payment Deadline" 
                        fieldId="payment-deadline" 
                        requiredField={false}
                        inputType="text" 
                        preloadValue={''}
                        hasError={false} 
                        returnFieldValue={(value)=>{
                            const formattedDate = new Date(value)
                            setPaymentDeadline(formattedDate)
                        }}
                    />
                </div>

                <p className='text-sm text-gray-500'>Select an invoice below and click on "Assign invoice" to assign an invoice to <span className='text-gray-800 font-[500]'>{student.fullName}</span></p>

                <div className='w-full mt-[20px]'>
                    <SearchField 
                        placeholderText={`Search for invoice by name or invoice code`}
                        showResultsDropDown={false}
                        triggerSearch={(term)=>{searchInvoices(term)}}
                        performingSearch={invoicesSelector.loadingInvoices}
                    />
                </div>

                <div className=' h-[250px] max-h-[500px]'>
                    {invoicesSelector?.loadingInvoices ? 
                        <Loader />
                        :
                        <>
                            {invoicesSelector.invoices?.invoices?.length > 0 ?
                                <div className='w-full mt-[20px]'>
                                    {invoicesSelector.invoices.invoices.map((invoice, index) => (
                                        <div 
                                            key={index} 
                                            onClick={()=>{toggleInvoiceSelection(invoice)}}
                                            className={`w-full flex items-start justify-between gap-x-[10px] p-[10px] cursor-pointer transition duration-200 border  hover:bg-vcm-light-purple hover:bg-opacity-10 hover:border-vcm-purple rounded-[8px] relative mb-[5px] hover:border-opacity-50
                                            ${selectedInvoice._id === invoice._id ? 'bg-vcm-light-purple bg-opacity-5' : 'border-transparent bg-transparent'}
                                            `}
                                        >
                                            <div className='w-full'>
                                                <h3 className='font-[550] text-sm'>{invoice.name}</h3>
                                                <p className='text-xs my-[5px] text-gray-400 truncate'>{invoice.description}</p>
                                                <FeesDisplay fees={invoice.fees} />
                                            </div>
                                            <div className=''>
                                                <h3 className='mt-[5px] text-sm font-[550]'>₦{(invoice.total/100).toLocaleString()}</h3>

                                                {selectedInvoice._id === invoice._id && 
                                                <div className='transition duration-200 w-[20px] h-[20px] rounded-full bg-vcm-purple flex items-center justify-center absolute bottom-[10px] right-[10px]'>
                                                    <CheckIcon className={`w-4 h-4 text-white`} />
                                                </div>}
                                            </div>
                                        </div>
                                        )
                                    )}
                                </div> 
                                :
                                <EmptyState emptyStateText={`No active invoices. Please navigate to the invoices page to create a new invoice.`} />
                            }
                        </>
                    }
                </div>

                <div className='mb-[10px] flex items-start justify-between gap-x-[10px] mt-[10px]'>
                    <div className='w-10/12'>
                        <p className="block font-space-grotesk text-[14px] font-[550] font-sofia-pro">Add Student Sundries</p>
                        <label className="text-sm text-gray-500 font-sofia-pro">Flip this switch to add the student's unpaid sundry expenses to this invoice.</label>
                    </div>
                    <div className='w-2/12 flex flex-row-reverse pt-[15px]'>
                        <Switch
                            checked={sundriesRequirement.include}
                            onChange={()=>{setSundriesRequirement({...sundriesRequirement, include: !sundriesRequirement.include})}}
                            className={`${
                                sundriesRequirement.include ? 'bg-accent' : 'bg-gray-400'
                            } relative inline-flex items-center h-5 rounded-full w-10`}
                            >
                            <span className="sr-only">Add Sundries</span>
                            <span
                                className={`transform transition ease-in-out duration-200 ${
                                    sundriesRequirement.include ? 'translate-x-6 bg-primary' : 'translate-x-1 bg-gray-600'
                                } inline-block w-3 h-3 transform rounded-full`}
                            />
                        </Switch>
                    </div>
                </div>

                {sundriesRequirement.include && 
                    <>
                        <div className='w-full mt-[10px] mb-[10px]'>
                            <div className='w-full'>
                                <p className='text-sm'>Select a date range to pick sundry expenses from</p>

                                <div className='w-full flex items-start justify-between gap-x-[5px]'>
                                    <div className='my-2 w-full'>
                                        <DateField
                                            inputLabel="Date From" 
                                            fieldId="sundry-date-from" 
                                            requiredField={false}
                                            inputType="text" 
                                            preloadValue={''}
                                            hasError={validationErrors && validationErrors.sundriesDateFrom} 
                                            returnFieldValue={(value)=>{
                                                const formattedDate = new Date(value)
                                                setSundriesRequirement({...sundriesRequirement, ...{dateFrom: formattedDate}})
                                            }}
                                        />
                                    </div>
                                    <div className='my-2 w-full'>
                                        <DateField
                                            inputLabel="Date to" 
                                            fieldId="sundry-date-to" 
                                            requiredField={false}
                                            inputType="text" 
                                            preloadValue={''}
                                            hasError={validationErrors && validationErrors.sundriesDateTo} 
                                            returnFieldValue={(value)=>{
                                                const formattedDate = new Date(value)
                                                setSundriesRequirement({...sundriesRequirement, ...{dateTo: formattedDate}})
                                            }}
                                        />
                                    </div>
                                </div>
                            </div>

                        </div>
                        
                        <div className='my-[10px] flex items-start justify-between gap-x-[10px] mt-[10px]'>
                            <div className='w-10/12'>
                                <p className="block font-space-grotesk text-[14px] font-[550] font-sofia-pro">Refill sundries</p>
                                <label className="text-sm text-gray-500 font-sofia-pro">Flip this switch to refill the student sundries back to the required amount.</label>
                            </div>
                            <div className='w-2/12 flex flex-row-reverse pt-[15px]'>
                                <Switch
                                    checked={topupSundries}
                                    onChange={()=>{setTopupSundries(!topupSundries)}}
                                    className={`${
                                        topupSundries ? 'bg-accent' : 'bg-gray-400'
                                    } relative inline-flex items-center h-5 rounded-full w-10`}
                                    >
                                    <span className="sr-only">Topup Sundries</span>
                                    <span
                                        className={`transform transition ease-in-out duration-200 ${
                                            topupSundries ? 'translate-x-6 bg-primary' : 'translate-x-1 bg-gray-600'
                                        } inline-block w-3 h-3 transform rounded-full`}
                                    />
                                </Switch>
                            </div>
                        </div>

                        {topupSundries && 
                            <div className='w-full mt-[10px]'>
                                <div className='w-full my-2'>
                                    <SelectField
                                        selectOptions={selectedInvoice?.fees?.map(fee => fee.fee)}
                                        inputLabel="Select sundry fee"
                                        titleField="name"
                                        displayImage={false} 
                                        imageField=""
                                        requiredField={false}
                                        preSelectedIndex={selectedInvoice?.fees?.map(fee => fee.fee)?.findIndex(fee => fee?._id === sundriesRequirement.sundryTopupFee)}
                                        fieldId="center-select"
                                        hasError={validationErrors.sundryTopupFee}
                                        // return id of accounts of the selected option
                                        returnFieldValue={(value) => {
                                            setSundriesRequirement({...sundriesRequirement, ...{sundryTopupFee: value._id}})
                                        }}
                                    /> 
                                    <p className='mt-1 text-[13px] text-gray-500'>This is the fee that tops up the sundry balance - if there's none in the invoice, edit the invoice to add one.</p>
                                </div>
                            </div>
                        }
                    </>                       
                }

            </div>
            <div className="mt-8 flex flex-row-reverse gap-x-4">
                <ModalActionButton
                    buttonLabel={`Assign Invoice`}
                    buttonAction={()=>{pushAssignment()}}
                    processing={invoicesSelector.creatingInvoiceAssignment}
                />

                <button
                    type="button"
                    className="inline-flex justify-center px-5 py-4 text-xs font-medium bg-transparent border border-transparent rounded-lg transition duration-200 hover:bg-opacity-20 hover:bg-secondary focus:outline-none"
                    onClick={closeFunction}
                >
                    Cancel
                </button>
            </div>
        </div>
    )
}

export default AssignInvoiceToStudent